import { isMyWMApp } from "utils-lib/isMyWMApp"
import MyWMTextInput from "./MyWMTextInput"
import AEMTextInput from "./AEMTextInput"

export default isMyWMApp ? MyWMTextInput : AEMTextInput
